var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Head',{attrs:{"title":_vm.parsedTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }